import { axios } from '@/services/axios';

const getCompanyPlatformUsers = async (
    companyID,
    platformId,
    accountScope,
) => {
    const res = await axios.get(
        `/PlatformUsers/${companyID}/platform/${platformId}`,
        {
            headers: {
                'X-RequestScope': accountScope,
            },
            // params: {
            //     userType: userType,
            // },
        },
    );
    return res.data;
};

export default getCompanyPlatformUsers;
